/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsloaderror3Inputs */

const en_listingbuttonsloaderror3 = /** @type {(inputs: Listingbuttonsloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The buttons could not be loaded.`)
};

const de_listingbuttonsloaderror3 = /** @type {(inputs: Listingbuttonsloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Knöpfe konnten nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "The buttons could not be loaded." |
*
* @param {Listingbuttonsloaderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsloaderror3 = /** @type {((inputs?: Listingbuttonsloaderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsloaderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsloaderror3(inputs)
	return de_listingbuttonsloaderror3(inputs)
});
export { listingbuttonsloaderror3 as "listingButtonsLoadError" }